import React from 'react';
import { BadgeText, FinePrint, InstallmentLabel, ProposalContainer, ProposalContent, TermCostLabel, TermPriceLabel, TextTitle, Badge, DiscountProposalContent, DiscountProposalIcon, DiscountProposalText, DiscountedPriceLabel, OriginalPriceLabel, CurrencySymbol } from './loan-proposal-card.styled';
import { ColorAddiCompThreeLighten1, } from '@addi/foundation/dist/web/colors';
export const OnboardingTitle = ({ text, fontColor }) => {
    return (React.createElement(TextTitle, { color: fontColor }, text));
};
export const OnboardingFinePrint = ({ text }) => {
    return (React.createElement(FinePrint, null, text));
};
export const LoanProposalCard = ({ labels, showZeroInterest, fontColor, priceColor, badgeFontColor, badgeBackgroundColor, badgeBorderRadius }) => {
    const { termCostLabel, installmentLabel, zeroInterestLabel } = labels;
    return (React.createElement(ProposalContainer, null,
        React.createElement(ProposalContent, null,
            React.createElement(TermCostLabel, { color: fontColor }, termCostLabel),
            React.createElement(InstallmentLabel, { color: priceColor }, installmentLabel),
            showZeroInterest &&
                React.createElement(Badge, { backgroundColor: badgeBackgroundColor, borderRadius: badgeBorderRadius },
                    React.createElement(BadgeText, { color: badgeFontColor }, zeroInterestLabel)))));
};
export const LoanProposalDiscountCard = ({ discountIcon, title, labels, showZeroInterest, fontColor, priceColor, badgeFontColor, badgeBackgroundColor, badgeBorderRadius }) => {
    const { currencySymbol, normalPrice, discountPriceLabel, discountPrice, installmentLabel, termCostLabel, zeroInterestLabel } = labels;
    return (React.createElement(ProposalContainer, null,
        React.createElement(DiscountProposalContent, { backgroundColor: ColorAddiCompThreeLighten1 },
            React.createElement(DiscountProposalIcon, null,
                React.createElement("img", { src: discountIcon, alt: "discount icon" })),
            React.createElement(DiscountProposalText, null,
                React.createElement(TermPriceLabel, { strong: true }, discountPriceLabel),
                React.createElement(DiscountedPriceLabel, null,
                    React.createElement(CurrencySymbol, null, currencySymbol),
                    discountPrice),
                React.createElement(OriginalPriceLabel, null, normalPrice))),
        title && React.createElement(OnboardingTitle, { fontColor: fontColor, text: title }),
        React.createElement(ProposalContent, null,
            React.createElement(TermCostLabel, { color: fontColor }, termCostLabel),
            installmentLabel && React.createElement(InstallmentLabel, { color: priceColor }, installmentLabel),
            showZeroInterest &&
                React.createElement(Badge, { backgroundColor: badgeBackgroundColor, borderRadius: badgeBorderRadius },
                    React.createElement(BadgeText, { color: badgeFontColor }, zeroInterestLabel)))));
};
//# sourceMappingURL=loan-proposal-card.js.map